module.exports = require("./nds.js");